import { format } from "date-fns"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import PlaceholderIcon from "@/assets/icons/misc/placeholder-icon.tsx"
import { CROP_PLANTING_EVENT_VIEW } from "@/features/events/crop-planting-events/routes/route-list.ts"
import { type CropPlantingEvent } from "@/features/events/crop-planting-events/types/crop-planting-event.ts"
import { type ItemsArray } from "@/utils/helpers/time-grouping.ts"

interface Props {
  cropPlantingEvent: CropPlantingEvent
}

const CropPlantingEventCardWrapper: React.FC<{ item: ItemsArray[number] }> = ({
  item,
}) => {
  return <CropPlantingEventCard cropPlantingEvent={item as CropPlantingEvent} />
}

const CropPlantingEventCard: React.FC<Props> = ({ cropPlantingEvent }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const navigateToEvent = () => {
    navigate(
      CROP_PLANTING_EVENT_VIEW.replace(
        ":cropPlantingEventId",
        cropPlantingEvent.id,
      ),
    )
  }

  return (
    <div
      onClick={navigateToEvent}
      className="box-border flex min-h-[60px] w-full items-center justify-between gap-2.5 rounded-[--fp-border-radius] border border-neutral-200 bg-white px-[15px] py-[7px]"
    >
      <div className={"grid place-content-center"}>
        {cropPlantingEvent.type_picture ? (
          <img
            src={cropPlantingEvent.type_picture}
            alt={t("eventPicture")}
            className={"h-[30px] w-[30px] rounded-[8px] bg-brown-500 p-1"}
          />
        ) : (
          <PlaceholderIcon />
        )}
      </div>
      <div className="flex h-10 flex-1 flex-col justify-between">
        <div
          className={
            "grid grid-cols-[auto_auto] items-center justify-between gap-[10px]"
          }
        >
          <div className={"truncate text-body-sm"}>
            {t(cropPlantingEvent.type_name)}
          </div>
          <div>{format(new Date(cropPlantingEvent.date), "dd.MM.yyyy")}</div>
        </div>
        <div className="flex items-start justify-start gap-[5px] text-[--dark-grey] opacity-50">
          <p className={"font-semibold opacity-80"}>{t("parcel")}</p>
          <p>{cropPlantingEvent.crop_name}</p>
        </div>
      </div>
    </div>
  )
}

export { CropPlantingEventCard, CropPlantingEventCardWrapper }
